import apiClient from "../utils/axiosConfig";
import { getApiUrl, API_ENDPOINTS } from "../Configurations/config";

const SALES_DIAGNOSIS_TIMEOUT_MS = 30000;

const requestConfig = (extra = {}) => ({
  timeout: SALES_DIAGNOSIS_TIMEOUT_MS,
  ...extra,
});

// Normalises month to YYYY-MM (e.g. 202601 -> 2026-01). Leaves YYYY-MM untouched.
function formatMonth(yearmonth) {
  if (!yearmonth) return yearmonth;
  return String(yearmonth).replace(/(\d{4})(\d{2})/, "$1-$2");
}

export async function getFiscalYears() {
  const response = await apiClient.get(
    getApiUrl(API_ENDPOINTS.AI_SALES_DIAGNOSIS.FISCAL_YEARS),
    requestConfig()
  );
  return response.data;
}

export async function getMonths(fiscal_year) {
  const response = await apiClient.get(
    getApiUrl(API_ENDPOINTS.AI_SALES_DIAGNOSIS.MONTHS),
    requestConfig({ params: { fiscal_year } })
  );
  return response.data;
}

export async function getDivisions(month) {
  const response = await apiClient.get(
    getApiUrl(API_ENDPOINTS.AI_SALES_DIAGNOSIS.DIVISIONS),
    requestConfig({ params: { month } })
  );
  return response.data;
}

export async function getTerritories(yearmonth, division) {
  const response = await apiClient.get(
    getApiUrl(API_ENDPOINTS.AI_SALES_DIAGNOSIS.TERRITORIES),
    requestConfig({ params: { yearmonth, division } })
  );
  return response.data;
}

export async function getDashboardData(yearmonth, division, territory) {
  const response = await apiClient.get(
    getApiUrl(API_ENDPOINTS.AI_SALES_DIAGNOSIS.DASHBOARD),
    requestConfig({
      params: {
        month: formatMonth(yearmonth),
        division,
        territory,
      },
    })
  );
  return response.data;
}

export async function getEmployees(
  yearmonth,
  division,
  territory,
  page = 1,
  pageSize = 10
) {
  const response = await apiClient.get(
    getApiUrl(API_ENDPOINTS.AI_SALES_DIAGNOSIS.EMPLOYEES),
    requestConfig({
      params: {
        yearmonth: formatMonth(yearmonth),
        division,
        territory,
        page,
        page_size: pageSize,
      },
    })
  );
  return response.data;
}

// employeeId -> "emp-10015653"; status -> "all" | "met" | "missed"
export async function getEmployeeDetail(
  employeeId,
  yearmonth,
  division,
  territory,
  page = 1,
  pageSize = 20,
  status = "all"
) {
  const empCode = String(employeeId || "").replace(/^emp-/, "");
  const statusMap = { all: "All", met: "Met", missed: "Missed" };
  const statusParam = statusMap[status] ?? "All";

  const response = await apiClient.get(
    getApiUrl(API_ENDPOINTS.AI_SALES_DIAGNOSIS.EMPLOYEE(empCode)),
    requestConfig({
      params: {
        ...(yearmonth && { yearmonth: formatMonth(yearmonth) }),
        ...(division && { division }),
        ...(territory && { territory }),
        page,
        page_size: pageSize,
        status: statusParam,
      },
    })
  );
  return response.data;
}

export default apiClient;
